import { ChangeEvent, useContext } from 'react';

import SchemaDetailContext from '@atom/components/schemaDetail/SchemaDetailContext';
import { RadioGroup, Switch } from '@atom/mui';
import {
  SchemaBudget,
  StartEndReadingOption,
  StockBasedOption,
} from '@atom/types/schema';

import classes from './costDetail.module.css';

const { RadioButton } = RadioGroup;

interface Props {
  budget: SchemaBudget;
  setBudget: (budget: SchemaBudget) => void;
  updateBudget: (budget: SchemaBudget) => void;
}

const StockSection = ({ budget, setBudget, updateBudget }: Props) => {
  const { schemaTree } = useContext(SchemaDetailContext);

  const { stockBasedOption } = budget;

  const toggled =
    stockBasedOption === StockBasedOption.STOCK_BASED ||
    stockBasedOption === StockBasedOption.STOCK_BASED_OPTIONAL;

  const updateStockBasedOption = (option: StockBasedOption) => {
    const updatedBudget = {
      ...budget,
      stockBasedOption: option,
      startEndReadingOption: StartEndReadingOption.NONE,
    };

    setBudget(updatedBudget);
    updateBudget(updatedBudget);
  };

  const handleToggle = () => {
    const option =
      stockBasedOption === StockBasedOption.NONE
        ? StockBasedOption.STOCK_BASED
        : StockBasedOption.NONE;

    const updatedBudget = {
      ...budget,
      stockBasedOption: option,
      startEndReadingOption: StartEndReadingOption.NONE,
    };

    setBudget(updatedBudget);
    updateBudget(updatedBudget);
  };

  const isDisabled = schemaTree.isPublished;

  return (
    <div className={classes.costContainer}>
      <Switch
        checked={toggled}
        onChange={handleToggle}
        label="Stock-based Inventory"
        disabled={isDisabled}
      />
      {toggled && (
        <RadioGroup
          value={stockBasedOption}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            updateStockBasedOption(event.target.value as StockBasedOption)
          }
        >
          <RadioButton
            value={StockBasedOption.STOCK_BASED}
            label="Default"
            disabled={isDisabled}
          />
          <div className={classes.optionSubtext}>
            Set an available inventory level and track usage for all inventory
            of this type.
          </div>
          <RadioButton
            value={StockBasedOption.STOCK_BASED_OPTIONAL}
            label="Optional"
            disabled={isDisabled}
          />
          <div className={classes.optionSubtext}>
            Set an available inventory level and track usage at the individual
            inventory item level.
          </div>
        </RadioGroup>
      )}
    </div>
  );
};

export default StockSection;
